<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  mounted() {
    console.log(123)
    console.log(process.env.NODE_ENV)
    console.log(process.env.VUE_APP_BASE_API)
  }
}
</script>
